<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">receipt_long</span>
      <h2>Inventaire</h2>
    </div>

    <p class="section-intro">
      Le module Inventaire permet de déclarer les écarts constatés lors des comptages physiques :
      manquants (stock réel &lt; stock système) ou excédents (stock réel &gt; stock système).
    </p>

    <!-- ===== DÉCLARER UN ÉCART ===== -->
    <h3 class="sub-title">Déclarer un écart d'inventaire</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Champ</th><th>Type</th><th>Obligatoire</th><th>Ce qu'il faut saisir</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Produit</strong></td><td>Texte (désactivé)</td><td>—</td><td>Nom du produit (affiché automatiquement).</td></tr>
          <tr><td><strong>Type</strong></td><td>Texte (désactivé)</td><td>—</td><td>Catégorie du produit.</td></tr>
          <tr><td><strong>Quantité en stock (système)</strong></td><td>Nombre (désactivé)</td><td>—</td><td>Quantité théorique dans le système.</td></tr>
          <tr><td><strong>Type de déficit</strong></td><td>Liste déroulante</td><td><span class="required-badge badge-yes">Oui</span></td><td>Choisir : <em>Manquant</em> (stock réel inférieur) ou <em>Excédent</em> (stock réel supérieur).</td></tr>
          <tr><td><strong>Quantité de déficit</strong></td><td>Nombre</td><td><span class="required-badge badge-yes">Oui</span></td><td>La différence constatée entre le stock physique et le stock système.</td></tr>
          <tr><td><strong>Fichier preuve</strong></td><td>Fichier</td><td><span class="required-badge badge-no">Non</span></td><td>Photo du comptage ou PV d'inventaire.</td></tr>
          <tr><td><strong>Observation</strong></td><td>Texte</td><td><span class="required-badge badge-no">Non</span></td><td>Explication de l'écart.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure : Enregistrer un écart</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Ouvrez le module <strong>Inventaire</strong> depuis le menu latéral.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Le tableau affiche le stock actuel de chaque produit. Cliquez sur un produit présentant un écart.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Les champs <em>Produit</em>, <em>Type</em> et <em>Quantité en stock</em> sont pré-remplis et non modifiables.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p>Sélectionnez le <em>Type de déficit</em> : <strong>Manquant</strong> si le stock réel est inférieur, <strong>Excédent</strong> si le stock réel est supérieur.</p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p>Saisissez la <em>Quantité de déficit</em> (la différence entre le stock système et le stock réel, en valeur absolue).</p>
      </div>
      <div class="step-item">
        <div class="step-num">6</div>
        <p>Joignez un <em>Fichier preuve</em> si disponible (PV d'inventaire, photo du comptage).</p>
      </div>
      <div class="step-item">
        <div class="step-num">7</div>
        <p>Ajoutez une <em>Observation</em> expliquant l'écart.</p>
      </div>
      <div class="step-item">
        <div class="step-num">8</div>
        <p>Cliquez sur <span class="btn-ref">Soumettre</span>. L'écart est enregistré et en attente de traitement par l'administrateur (voir module Pertes).</p>
      </div>
    </div>

    <div class="info-card tip">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#4caf50">lightbulb</span>
        Astuce
      </div>
      <p>
        En cas d'<strong>excédent</strong>, des champs supplémentaires peuvent apparaître pour préciser si le surplus doit être intégré au stock. 
        Le comportement exact dépend de la valeur du champ <em>isSurPlus</em> dans le système.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocInventaire" };
</script>
